import { useRef, useState } from 'react';

/**
 * Controlled state for an anchored BUI <Popover> driven by a plain button.
 *
 * A native <button> cannot be a DialogTrigger child: React Aria attaches
 * onPress to the trigger via cloneElement, and only its own press components
 * honor that prop — a raw button ignores it, so the popover never opens.
 * Own the open state instead, wire the returned triggerRef/onClick into the
 * button and spread popoverProps onto <Popover>.
 */
export const useSelectPopover = () => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setOpen] = useState(false);
  return {
    triggerRef,
    isOpen,
    toggle: () => setOpen(current => !current),
    popoverProps: { isOpen, onOpenChange: setOpen, triggerRef },
  };
};
